import { render, staticRenderFns } from "./ipt-select.vue?vue&type=template&id=5ffd7055&scoped=true&"
import script from "./ipt-select.vue?vue&type=script&lang=ts&"
export * from "./ipt-select.vue?vue&type=script&lang=ts&"
import style0 from "./ipt-select.vue?vue&type=style&index=0&id=5ffd7055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffd7055",
  null
  
)

export default component.exports